import { ChevronDown, ChevronUp } from '@ifood/pomodoro-icons';
import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

import { BlankButton } from '../BlankButton';

export const HeaderButton = styled(BlankButton)`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
  text-align: left;
`;

const IconStyle = `
  width: 24px;
  height: 24px;
  color: ${tokens.colors.primary};
`;

export const ArrowUp = styled(ChevronUp)`
  ${IconStyle}
`;
export const ArrowDown = styled(ChevronDown)`
  ${IconStyle}
`;

export const Content = styled.div`
  padding-top: ${tokens.space.regular};
  color: ${tokens.colors.grayDarkest};
  font-size: ${tokens.fontSizes.s};
  line-height: ${tokens.lineHeights.m};
`;
